import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Empaque } from '../interfaces/beans.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmpaqueService {

  url = environment.url + '/empaques';

  constructor(private http: HttpClient) {
  }

  count() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/count`, { headers }).pipe( map( data => data));
  }

  getAll(paginaActual: number, registrosPorPagina: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/all?pagina=${ paginaActual }&registros=${ registrosPorPagina }`, { headers }).pipe( map( data => data));
  }

  getFull() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/full`, { headers }).pipe( map( data => data));
  }

  add(empaque: Empaque) {
    let body = JSON.stringify(empaque);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.post(`${ this.url }/add?cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }

  update(empaque: Empaque) {
    let body = JSON.stringify(empaque);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.put(`${ this.url }/update?cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }

  delete(empaque: Empaque) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.delete(`${ this.url }/delete/?empaque=${ empaque.id }&cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, { headers }).pipe( map( data => data));
  }
}
